import React from "react";
import { api } from "@/lib/api";

/** Quick-reply chip strip shown above the chat input while the conversation is empty.
 * The most-clicked chip (per backend stats) is promoted to a "Popular" badge. */
export default function QuickReplies({ chips, onPick }) {
  if (!Array.isArray(chips) || chips.length === 0) return null;
  const handlePick = (chip) => {
    api.post("/chat/chip-click", { chip }).catch(() => {});
    onPick(chip);
  };
  const [featured, ...rest] = chips;
  return (
    <div className="md-ai-quick-replies" data-testid="ai-chat-quick-replies">
      <button
        type="button"
        onClick={() => handlePick(featured)}
        className="md-ai-quick-chip md-ai-quick-chip-featured"
        data-testid="ai-chat-quick-featured"
      >
        <span className="md-ai-quick-featured-label">Popular</span>
        <span className="md-ai-quick-featured-text">{featured}</span>
      </button>
      {rest.map((q) => (
        <button
          key={q}
          type="button"
          onClick={() => handlePick(q)}
          className="md-ai-quick-chip"
          data-testid={`ai-chat-quick-${q.slice(0, 20).replace(/\s+/g, "-").toLowerCase()}`}
        >
          {q}
        </button>
      ))}
    </div>
  );
}
